/**
 * Runs the details lookup for a picked address and keeps the result only if
 * that address is still the picked one when it returns: a newer pick, or
 * typing over it, makes the result stale.
 */
export const lookupForPick = async <T>(
  picked: string,
  currentPick: () => string | null,
  lookup: () => Promise<T>,
): Promise<T | undefined> => {
  const result = await lookup();
  return currentPick() === picked ? result : undefined;
};
